import { render, staticRenderFns } from "./ObjectViewGraphView.vue?vue&type=template&id=2fc97e6a&scoped=true"
import script from "./ObjectViewGraphView.vue?vue&type=script&lang=js"
export * from "./ObjectViewGraphView.vue?vue&type=script&lang=js"
import style0 from "./ObjectViewGraphView.vue?vue&type=style&index=0&id=2fc97e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc97e6a",
  null
  
)

export default component.exports